import * as React from "react";
import { forwardRef, memo } from "react";
const SvgNearMeOutlinedLarge = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 11.5091L22 2.0354L12.5263 22.0354L10.4211 13.6143L2 11.5091Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgNearMeOutlinedLarge);
const Memo = memo(ForwardRef);
export default Memo;
